import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { openWhatsApp } from "../lib/whatsapp";

export const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 22 }}
          onClick={() => openWhatsApp()}
          data-testid="floating-whatsapp-button"
          aria-label="Enquire on WhatsApp"
          className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-[60] flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3.5 shadow-[0_20px_50px_rgba(37,211,102,0.35)] hover:pl-5 hover:pr-6 animate-pulse-soft transition-all"
        >
          <svg
            viewBox="0 0 32 32"
            width="22"
            height="22"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M19.11 17.19c-.28-.14-1.66-.82-1.92-.91-.26-.09-.45-.14-.63.14-.19.28-.72.91-.88 1.1-.16.19-.32.21-.6.07-.28-.14-1.19-.44-2.26-1.39-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.19-.28.28-.46.09-.19.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.55-.46-.48-.63-.49l-.54-.01c-.19 0-.49.07-.75.35-.26.28-.98.96-.98 2.34s1.01 2.71 1.15 2.9c.14.19 1.99 3.03 4.83 4.24.67.29 1.19.47 1.6.6.67.21 1.28.18 1.76.11.54-.08 1.66-.68 1.89-1.33.23-.66.23-1.22.16-1.33-.07-.11-.26-.19-.54-.33zM16 3C9.37 3 4 8.37 4 15c0 2.28.63 4.42 1.72 6.24L4 29l7.94-1.66C13.68 28.42 14.82 29 16 29c6.63 0 12-5.37 12-12S22.63 3 16 3z" />
          </svg>
          <span className="hidden sm:inline font-sans text-[11px] uppercase tracking-[0.24em] font-medium">
            Chat on WhatsApp
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default FloatingWhatsApp;
